module.exports = __webpack_public_path__ + "img/register-bg.e90a23da.png";